<template>
  <div class="boss-search-preview-wrap">
    <div class="boss-search-preview">
      <div class="boss-layout boss-layout-vertical">
        <template v-if="isSearching">
          <div
            class="loader-mini"
            data-test="loader"
          />
        </template>
        <template v-else>
          <div>
            <div class="boss-layout boss-layout-gap-small boss-layout-search-preview">
              <div
                class="boss-search-preview-result"
                data-test="hit-num"
              >
                <template v-if="isError">
                  －
                </template>
                <template v-else>
                  {{ hit.num }}
                </template>
              </div>
              <div class="boss-search-preview-text">
                名
              </div>
            </div>
          </div>
          <div>
            <span
              disabled
              class="boss-button boss-button-fill pega-button"
            >
              <span class="boss-button-before boss-icon-triangle" />
              <span
                class="boss-button-text"
                data-test="search-button"
              >検索する
              </span>
            </span>
          </div>
        </template>
        <div>
          <label class="pega-input">
            <input
              v-model="isCheckedSaveSearch"
              type="checkbox"
              class="boss-input-checkbox"
              data-test="save-search-checkbox"
            >検索条件に名前を付けて保存する
          </label>
        </div>
        <div>
          <input
            :disabled="!isCheckedSaveSearch"
            type="text"
            class="boss-input boss-input-fill"
            placeholder="検索条件名を入力"
            data-test="save-search-condition-name"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  props: {
    searchCount: {
      type: Number,
      required: true
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isCheckedSaveSearch: false,
      hit: {
        num: 0
      }
    }
  },
  watch: {
    searchCount (val) {
      this.updateHitCount(val)
    }
  },
  methods: {
    updateHitCount (number) {
      anime({
        targets: this.hit,
        num: number,
        round: 1,
        duration: 1000,
        easing: 'easeOutCubic'
      })
    }
  }
}
</script>
